// Direct Manager Discrepancy Audit — mapping status badge configs (ADR-010 Phase 6).
//
// RADAR_ONLY rows are produced by radar-api, Region-scoped per source (ADR-130);
// the run detail page shows them in their own "Radar only" view.

export const DISCREPANCY_MAPPING_STATUSES = {
  MATCHED:              'MATCHED',
  UPSTREAM_ONLY:        'UPSTREAM_ONLY',
  RADAR_ONLY:           'RADAR_ONLY',
  MANAGER_UNMAPPED:     'MANAGER_UNMAPPED',
  // ADR-064: AMERICAS only — the reported representative cannot be determined
  // at all (no SDM in the MySM chain, broken chain, self-referential edge,
  // grace-window record). UNMAPPED = determined but not mappable to radar.
  MANAGER_UNDETERMINED: 'MANAGER_UNDETERMINED',
  AMBIGUOUS:            'AMBIGUOUS',
};

export const DISCREPANCY_MAPPING_STATUS_LABELS = {
  [DISCREPANCY_MAPPING_STATUSES.MATCHED]:              'Matched',
  [DISCREPANCY_MAPPING_STATUSES.UPSTREAM_ONLY]:        'Upstream only',
  [DISCREPANCY_MAPPING_STATUSES.RADAR_ONLY]:           'Radar only',
  [DISCREPANCY_MAPPING_STATUSES.MANAGER_UNMAPPED]:     'Representative unmapped',
  [DISCREPANCY_MAPPING_STATUSES.MANAGER_UNDETERMINED]: 'Representative undetermined',
  [DISCREPANCY_MAPPING_STATUSES.AMBIGUOUS]:            'Ambiguous',
};

export const DISCREPANCY_MAPPING_STATUS_COLORS = {
  [DISCREPANCY_MAPPING_STATUSES.MATCHED]:              'success',
  [DISCREPANCY_MAPPING_STATUSES.UPSTREAM_ONLY]:        'warning',
  [DISCREPANCY_MAPPING_STATUSES.RADAR_ONLY]:           'warning',
  [DISCREPANCY_MAPPING_STATUSES.MANAGER_UNMAPPED]:     'warning',
  [DISCREPANCY_MAPPING_STATUSES.MANAGER_UNDETERMINED]: 'warning',
  [DISCREPANCY_MAPPING_STATUSES.AMBIGUOUS]:            'error',
};

export const DISCREPANCY_MAPPING_STATUS_OPTIONS = Object.values(DISCREPANCY_MAPPING_STATUSES).map((value) => ({
  value,
  label: DISCREPANCY_MAPPING_STATUS_LABELS[value],
}));

// ADR-130: the representative-comparison views never include RADAR_ONLY rows
// (those have their own view), so the mapping-status filter omits it.
export const DISCREPANCY_COMPARABLE_MAPPING_STATUSES = Object.values(DISCREPANCY_MAPPING_STATUSES)
  .filter((value) => value !== DISCREPANCY_MAPPING_STATUSES.RADAR_ONLY);

export const DISCREPANCY_COMPARABLE_MAPPING_STATUS_OPTIONS = DISCREPANCY_MAPPING_STATUS_OPTIONS
  .filter((opt) => opt.value !== DISCREPANCY_MAPPING_STATUSES.RADAR_ONLY);

export const DISCREPANCY_SOURCE_SYSTEMS = {
  ENOVA: 'ENOVA',
  AMERICAS: 'AMERICAS', // ADR-064
};

export const DISCREPANCY_SOURCE_SYSTEM_OPTIONS = [
  { value: DISCREPANCY_SOURCE_SYSTEMS.ENOVA, label: 'Enova' },
  { value: DISCREPANCY_SOURCE_SYSTEMS.AMERICAS, label: 'Americas' },
];

// SyncRunStatusEnum values from radar-api (reused from existing schema).
export const DISCREPANCY_RUN_STATUSES = {
  RUNNING: 'running',
  SUCCESS: 'success',
  FAILED:  'failed',
};

export const DISCREPANCY_RUN_STATUS_LABELS = {
  [DISCREPANCY_RUN_STATUSES.RUNNING]: 'Running',
  [DISCREPANCY_RUN_STATUSES.SUCCESS]: 'Success',
  [DISCREPANCY_RUN_STATUSES.FAILED]:  'Failed',
};

export const DISCREPANCY_RUN_STATUS_COLORS = {
  [DISCREPANCY_RUN_STATUSES.RUNNING]: 'info',
  [DISCREPANCY_RUN_STATUSES.SUCCESS]: 'success',
  [DISCREPANCY_RUN_STATUSES.FAILED]:  'error',
};

export const DISCREPANCY_RUN_STATUS_OPTIONS = Object.values(DISCREPANCY_RUN_STATUSES).map((value) => ({
  value,
  label: DISCREPANCY_RUN_STATUS_LABELS[value],
}));
